export function getFeedPickerConfig() {
    const cfg = window.productPickerConfig || {};

    return {
        apiUrl: cfg.apiUrl || cfg.url || '/feedpicker/search',
        optionsUrl: cfg.optionsUrl || '/feedpicker/search/options',
        tastes: Array.isArray(cfg.tasteOptions) ? cfg.tasteOptions : [],
        specialNeedsCats: Array.isArray(cfg.catSpecialNeedsOptions) ? cfg.catSpecialNeedsOptions : [],
        specialNeedsDogs: Array.isArray(cfg.dogSpecialNeedsOptions) ? cfg.dogSpecialNeedsOptions : [],
        imageBaseUrl: String(cfg.imageBaseUrl || '').replace(/\/$/, ''),
    };
}
